import { observable, toJS, action } from "mobx";

import store, { goNextSlide, block, goNextSkip, hideBlock, showBlock } from "../canvas/store";
import { state as editorState } from "../layout/index";
import { ItemTypes } from "../constants/elements";
import dbStore, { flattenDB } from "../spreadsheet/store";

const cycleSlides = (sliderId, live) => {
  return setTimeout(() => {
    (editorState.isPreview || live) && block(sliderId) && goNextSlide(sliderId);
    (editorState.isPreview || live) && block(sliderId) && cycleSlides(sliderId, live);
  }, block(sliderId).idleDuration);
};

const cycleCollection = (blockId, live) => {
  return setTimeout(() => {
    (editorState.isPreview || live) && block(blockId) && goNextSkip(blockId);
    block(blockId) && cycleCollection(blockId, live);
  }, 3000);
};

const showEveryNsecs = (blockId, live) => {
  return setTimeout(() => {
    (editorState.isPreview || live) &&
      block(blockId) &&
      block(blockId).showEvery &&
      showBlock(blockId);

    block(blockId) &&
      setTimeout(() => {
        hideBlock(blockId);
        showEveryNsecs(blockId, live);
      }, block(blockId).stayDuration);
  }, block(blockId).showEvery || 4000);
};

var tasks = {};

var i = 0;
const loopMindCrack = () => {
  return setTimeout(
    () =>
      setInterval(() => {
        i++;
        if (
          dbStore.get("mindcrack") &&
          dbStore.get("mindcrack").props.bidwars &&
          Object.keys(dbStore.get("mindcrack").props.bidwars.value)
        ) {
          const bidwars = Object.keys(dbStore.get("mindcrack").props.bidwars.value);
          if (
            dbStore.get("custom") &&
            dbStore.get("custom").props.bidwar &&
            dbStore.get("custom").props.bidwar.value &&
            dbStore.get("custom").props.loopBidwar &&
            dbStore.get("custom").props.loopBidwar.value
          ) {
            dbStore.get("custom").props.bidwar.value = bidwars[i % bidwars.length];
          }
        }
      }, 16000),
    10000
  );
};

export const blockState = observable.map({});

var queues = {};

const makeQueue = blockId => {
  const b = block(blockId);
  if (b) {
    const items = flattenDB.get()[b.collection];
    const idget = b.collection + ".__id";
    if (items) {
      if (queues[blockId].seen.length === 0) {
        queues[blockId].seen = items.map(i => i[idget]);
        blockState.get(blockId).collectionData = items.concat(
          toJS(blockState.get(blockId).collectionData) || []
        );
      } else {
        const news = items.filter(i => !queues[blockId].seen.includes(i[idget])).reverse();
        queues[blockId].seen = items.map(i => i[idget]);
        queues[blockId].q = queues[blockId].q.concat(news);
        const newItem = queues[blockId].q.shift();
        if (newItem) {
          blockState.get(blockId).collectionData = [newItem].concat(
            toJS(blockState.get(blockId).collectionData) || []
          );
        }
      }
    }
    setTimeout(() => makeQueue(blockId), 6000);
  }
};

const customFn = {
  "twitch:176997821": loopMindCrack,
  "twitch:89127233": loopMindCrack
};

export default (live, userId) => {
  action("setupBlockState", val => {
    store.blocks.forEach(v => {
      if (!blockState.get(v.id)) {
        blockState.set(v.id, { liveCollectionData: false });
      }

      if (!tasks[v.id]) {
        v.type === ItemTypes.ELEMENT_SLIDER && (tasks[v.id] = cycleSlides(v.id, live));
        v.collection && v.cycle && (tasks[v.id] = cycleCollection(v.id, live));
        v.showEvery && (tasks[v.id] = showEveryNsecs(v.id, live));
      }

      // if (!queues[v.id]) {
      //   v.collection &&
      //     v.collection !== "none" &&
      //     (queues[v.id] = { q: [], seen: [] }) &&
      //     makeQueue(v.id);
      // }
    });
    customFn[userId] && !tasks["__mindcrack__"] && (tasks["__mindcrack__"] = customFn[userId]());
  })();
};

var collChans = {};
const csp = window.csp;

const createCollChan = id => {
  collChans[id] = csp.chan();
  csp.go(function*() {
    while (true) {
      const event = yield csp.take(collChans[id]);
      blockState.get(id).liveCollectionData = [event.item].concat(
        toJS(blockState.get(id).liveCollectionData) || []
      );
      yield csp.timeout(5000);
    }
  });
};

const ensureCollChans = (interestedIds, event) => {
  interestedIds.forEach(id => {
    if (!collChans[id]) {
      blockState.get(id).liveCollectionData = flattenDB.get()[event.collection];
      createCollChan(id);
    }
    csp.putAsync(collChans[id], event);
  });
};

const interestedCollBlocks = coll => {
  return store.blockIds.filter(id => block(id).collection === coll);
};

export const newCollectionItem = event => {
  ensureCollChans(interestedCollBlocks(event.collection), event);
};



// WEBPACK FOOTER //
// ./src/scheduler/index.js